import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Size2b01934yxlz5f as Size } from '../../models/Rect.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function resizeObserver(_this__u8e3s4) {
  return resizeObserver$1().odq(_this__u8e3s4);
}
function mutationObserver(_this__u8e3s4, recursive) {
  return mutationObserver$1().tdq(_this__u8e3s4, recursive);
}
function measureByDuplicate(_this__u8e3s4, max) {
  var tmp = _this__u8e3s4.cloneNode(true);
  var clone = tmp instanceof HTMLElement ? tmp : THROW_CCE();
  clone.style.visibility = 'hidden';
  clone.style.width = max.td0_1 < 9999.0 ? '' + max.td0_1 + 'px' : 'unset';
  clone.style.height = max.ud0_1 < 9999.0 ? '' + max.ud0_1 + 'px' : 'unset';
  clone.style.maxWidth = 'unset';
  clone.style.maxHeight = 'unset';
  clone.style.position = 'fixed';
  ensureNotNull(document.body).appendChild(clone);
  var out = new (Size())(clone.scrollWidth + 1.0, clone.scrollHeight + 1.0);
  ensureNotNull(document.body).removeChild(clone);
  return out;
}
var resizeObserver$1Class;
function resizeObserver$1() {
  if (resizeObserver$1Class === VOID) {
    class $ extends BaseListenable() {
      static odq($this_resizeObserver, $box) {
        if ($box === VOID)
          $box = {};
        $box.ndq_1 = $this_resizeObserver;
        var $this = this.sam($box);
        $this.mdq_1 = null;
        return $this;
      }
      ial() {
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new ResizeObserver((_unused_var__etf5q3, _unused_var__etf5q3_0) => {
          this.kal();
          return Unit_instance;
        });
        var $this$apply = this_0;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_1 = this.ndq_1;
        var tmp0_safe_receiver = this_1.vb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          $this$apply.observe(tmp0_safe_receiver);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this_1.ub3_1.v((it) => {
            $this$apply.observe(it);
            return Unit_instance;
          });
        }
        tmp.mdq_1 = this_0;
      }
      jal() {
        var tmp0_safe_receiver = this.mdq_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.disconnect();
        }
        this.mdq_1 = null;
      }
    }
    initMetadataForClass($);
    resizeObserver$1Class = $;
  }
  return resizeObserver$1Class;
}
var mutationObserver$1Class;
function mutationObserver$1() {
  if (mutationObserver$1Class === VOID) {
    class $ extends BaseListenable() {
      static tdq($this_mutationObserver, $recursive, $box) {
        if ($box === VOID)
          $box = {};
        $box.rdq_1 = $this_mutationObserver;
        $box.sdq_1 = $recursive;
        var $this = this.sam($box);
        $this.qdq_1 = null;
        return $this;
      }
      ial() {
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new MutationObserver((rec, _unused_var__etf5q3) => {
          var tmp0_elvis_lhs = this.rdq_1.vb3_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var e = tmp;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_0 = e.__suppressMutationObserverStyle;
          var tmp1_elvis_lhs = tmp_0 instanceof ArrayList() ? tmp_0 : null;
          var suppressedStyleChanges = tmp1_elvis_lhs == null ? ArrayList().w() : tmp1_elvis_lhs;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_1 = e.__suppressMutationObserverClass;
          var tmp2_elvis_lhs = tmp_1 instanceof ArrayList() ? tmp_1 : null;
          var suppressedClassChanges = tmp2_elvis_lhs == null ? ArrayList().w() : tmp2_elvis_lhs;
          var tmp3_elvis_lhs = e.getAttribute('style');
          var s = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
          var c = e.className;
          var anyNotSuppressed = false;
          var inductionVariable = 0;
          var last = rec.length;
          $l$loop_1: while (inductionVariable < last) {
            var it = rec[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var suppressedStyle = it.type === 'attributes' && it.attributeName === 'style' && equals(it.target, e) && suppressedStyleChanges.t1(s);
            if (suppressedStyle) {
              continue $l$loop_1;
            }
            var suppressedClass = it.type === 'attributes' && it.attributeName === 'class' && equals(it.target, e) && suppressedClassChanges.t1(c);
            if (suppressedClass) {
              continue $l$loop_1;
            }
            if (!(it.attributeName == null)) {
              var tmp_2 = it.target;
              var tmp4_safe_receiver = tmp_2 instanceof HTMLElement ? tmp_2 : null;
              var newValue = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.getAttributeNS(it.attributeNamespace, ensureNotNull(it.attributeName));
              var tmp5_elvis_lhs = it.oldValue;
              var tmp_3 = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
              if (equals(tmp_3, newValue == null ? '' : newValue))
                continue $l$loop_1;
            }
            anyNotSuppressed = true;
          }
          suppressedStyleChanges.v3();
          suppressedClassChanges.v3();
          var tmp_4;
          if (anyNotSuppressed) {
            this.kal();
            tmp_4 = Unit_instance;
          }
          return Unit_instance;
        });
        var $this$apply = this_0;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_1 = this.rdq_1;
        var tmp0_safe_receiver = this_1.vb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'org.w3c.dom.MutationObserverInit' call
          var subtree = this.sdq_1;
          var characterData = undefined;
          var characterDataOldValue = undefined;
          var attributeFilter = undefined;
          var o = {};
          o['childList'] = true;
          o['attributes'] = true;
          o['characterData'] = characterData;
          o['subtree'] = subtree;
          o['attributeOldValue'] = true;
          o['characterDataOldValue'] = characterDataOldValue;
          o['attributeFilter'] = attributeFilter;
          $this$apply.observe(tmp0_safe_receiver, o);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this_1.ub3_1.v((it) => {
            // Inline function 'org.w3c.dom.MutationObserverInit' call
            var subtree = this.sdq_1;
            var characterData = undefined;
            var characterDataOldValue = undefined;
            var attributeFilter = undefined;
            var o = {};
            o['childList'] = true;
            o['attributes'] = true;
            o['characterData'] = characterData;
            o['subtree'] = subtree;
            o['attributeOldValue'] = true;
            o['characterDataOldValue'] = characterDataOldValue;
            o['attributeFilter'] = attributeFilter;
            $this$apply.observe(it, o);
            return Unit_instance;
          });
        }
        tmp.qdq_1 = this_0;
      }
      jal() {
        var tmp0_safe_receiver = this.qdq_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.disconnect();
        }
        this.qdq_1 = null;
      }
    }
    initMetadataForClass($);
    mutationObserver$1Class = $;
  }
  return mutationObserver$1Class;
}
//region block: exports
export {
  measureByDuplicate as measureByDuplicate50c5johgli0l,
  mutationObserver as mutationObserver1idzofyamtyii,
  resizeObserver as resizeObserver1rxn81hcox9er,
};
//endregion

//# sourceMappingURL=helpers.commonHtml.js.mjs.map
